/*
 * @Author: masonzhou
 * @Date: 2024-01-30 15:39:22
 * @LastEditTime: 2024-02-02 17:27:24
 * @FilePath: \yl-cjsph-tms-operation-front\src\plugins\i18n\index.ts
 * @Description:
 */
// import { I18n } from "vue-i18n";
import { App } from 'vue';
export { default as avLang } from './lang/avue-crud';
export { default as epLang } from './lang/element-plus';
export { default as fsLang } from './lang/fast-crud';
import YlI18nRadio from './components/i18n-radio.vue';
import YlI18nSelect from './components/i18n-select.vue';
import useVueI18n from './hook';
import _i18n from './vueI18n';
export { LANG_ELEMENT_MAP, LANG_ELEMENT_PLUS_MAP } from './vueI18n';
function install(app: App, _options: any = {}) {
  // 注册多语言切换组件
  app.component('YlI18nRadio', YlI18nRadio);
  app.component('YlI18nSelect', YlI18nSelect);
  localStorage.setItem(
    'needLangList',
    JSON.stringify(_options.needLangList || ['EN', 'CN'])
  );
  // 初始化VueI18n和旧翻译数据
  const { _getLangJsonForLocal, asyncLangJson, setVueI18nMessage } = useVueI18n(
    _options.needLangList
  );
  const langJson: Object = _getLangJsonForLocal(); // langKey对应的翻译数据源
  if (langJson) {
    setVueI18nMessage(langJson);
  }
  // 同步新翻译数据
  asyncLangJson();
}
// export const LANG_ELEMENT_PLUS_MAP = _LANG_ELEMENT_PLUS_MAP;
// export const LANG_ELEMENT_MAP = _LANG_ELEMENT_MAP;
export const i18n = _i18n;
export const i18nGlobal: any = _i18n.global;
// 解决：类型实例化过深，且可能无限的问题
export const $t = i18nGlobal.t;
export const I18nPlugin = {
  install
};
